import React from "react";

//imported
import EmailPreferences from "pages/EmailPreferences/Index";

const EmailPreferencesTab = () => {
  return (
    <>
      <div className="top py-2">
        <h3 className="m-0 py-1 fw-bold">Email Preferences</h3>
      </div>
      <div className="TabBody py-3">
        <EmailPreferences embedded />
      </div>
    </>
  );
};

export default EmailPreferencesTab;
